var DIAGRAM_DOM = {
    // 重置卦详情页面的样式
    updateDiagramDetailStyle() {
        let topbarDiv = document.getElementsByClassName('diagram-detail-top-panel')[0];
        let contentDiv = document.getElementsByClassName('diagram-detail-main-content')[0];
        console.log('updateDiagramDetailStyle---', topbarDiv, contentDiv)
        if(topbarDiv && contentDiv){
            setTimeout(() => {
                contentDiv.style = '';
                contentDiv.style.paddingTop = topbarDiv.clientHeight + 'px'; 
                // window.scrollTo(0, 0);
        }, 100);
        }
    },
    updateDiagramDetailEditPanelStyle(curDiv) {
        let topbarDiv = document.getElementsByClassName('diagram-detail-top-panel')[0];
        let contentDiv = document.getElementsByClassName('diagram-detail-main-content')[0];
        let scrollDiv = curDiv.parentNode.parentNode.previousElementSibling;
        let scrollId = scrollDiv ? scrollDiv.id : '';
        let scrollY = 70;
            scrollY = scrollId == 'diagramAnalyse' ? DIAGRAM_DOM.getPreElSibling(scrollDiv, 1).clientHeight+90 : scrollY;
            scrollY = scrollId == 'diagramFeedBack' ? scrollDiv.clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 2).clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 4).clientHeight+115 : scrollY;
            scrollY = scrollId == 'diagramReview' ? DIAGRAM_DOM.getPreElSibling(scrollDiv, 1).clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 2).clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 3).clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 5).clientHeight+DIAGRAM_DOM.getPreElSibling(scrollDiv, 7).clientHeight+135 : scrollY;
        console.log('updateDiagramDetailEditPanelStyle----', curDiv, scrollDiv, scrollId, scrollY)
        setTimeout(() => {
            contentDiv.style = '';
            contentDiv.style.paddingTop = topbarDiv.clientHeight + 'px'; 
            contentDiv.style.paddingBottom = '500px';
            window.scrollTo(0, scrollY);
        }, 100);
    },
    getPreElSibling(curDiv, num) {
        let retDiv = curDiv;
        switch(num) {
            case 1:
                retDiv = curDiv.previousElementSibling;
                break;
            case 2:
                retDiv = curDiv.previousElementSibling.previousElementSibling;
                break;
            case 3:
                retDiv = curDiv.previousElementSibling.previousElementSibling.previousElementSibling;
                break;
            case 4:
                retDiv = curDiv.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling;
                break;
            case 5:
                retDiv = curDiv.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling;
                break;
            case 7:
                retDiv = curDiv.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling.previousElementSibling;
                break;
        }
        return retDiv;
    }
}

export {
    DIAGRAM_DOM
}
